<div *ngIf="!isUpdateAccountClicked" class="modal-body">
  <div class="row hide-x-scroll">

    <div class="col-lg-2 col-md-2 col-sm-3 col-3 text-center pr-0">
      <img *ngIf="accountDetail.logo" class="full-img" src="{{accountDetail.logo}}" alt="{{accountDetail.name}}" />
      <img *ngIf="!accountDetail.logo" class="img-fluid" src="assets/images/placeholder.png" alt="alt"
        style="width:auto; height: 8vh" />
    </div>
    <div class="col-lg-10 col-md-10 col-sm-9 col-9">
      <div class="font-nissan-brand-w01-bold">
        <h4>{{accountDetail.name | uppercase}}</h4>
      </div>
      <div class="form-group">
        <label for="vin">Address</label>
        <i class="fas fa-edit cursor-pointer ml-3 maroon" data-toggle="tooltip" data-placement="right"
          title="Update Company Profile" (click)="openUpdateAccount()"></i>
        <div class="font14-600"><span
            *ngIf="accountDetail.address.street">{{accountDetail.address.street}},&nbsp;</span><span
            *ngIf="accountDetail.address.city">{{accountDetail.address.city}},&nbsp;</span><span
            *ngIf="accountDetail.address.state">{{accountDetail.address.state}},&nbsp;</span>{{accountDetail.address.postalCode}}
        </div>
      </div>

      <!-- <div class="form-group">
        <div class="font14-400">
          <div class="mb-1"><span>Locale:&nbsp;</span> <span>USA&nbsp;</span></div>
          <div class="d-flex align-items-start">
            <div class="d-inline-block"><span>Timezone:&nbsp;</span></div>
            <div class="d-inline-block">
              <div>{{timezone[0]}}&nbsp;</div>
              <div>{{timezone[1]}}&nbsp;</div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="form-group">
        <label for="vin">Contact Information</label>
        <!-- {{accountDetail | json}} -->
        <div *ngIf="accountDetail.email" class="font14-600">Email: <span
            class="font13-400 text-muted">{{accountDetail.email}}</span></div>
        <div *ngIf="accountDetail.phone" class="font14-600">Phone: <span
            class="font13-400 text-muted">{{accountDetail.isd}}{{accountDetail.phone}}</span></div>
        <div *ngIf="!accountDetail.email && !accountDetail.phone" class="font13-400 text-muted">Not Updated</div>
      </div>


      <div class="form-group">
        <div class="row">
          <div class="col-9 pr-0">
            <label for="vin">Admin account domains</label>
            <i *ngIf="!isEditDomainEnabled" class="fas fa-edit cursor-pointer ml-3 maroon" data-toggle="tooltip"
              data-placement="right" title="Update Domains" (click)="enableEditingDomain()"></i>
            <i *ngIf="isEditDomainEnabled" class="fa fa-window-close cursor-pointer ml-3 maroon" data-toggle="tooltip"
              data-placement="right" title="Cancel" (click)="enableEditingDomain()"></i>
            <!-- <button class="btn btn-outline-danger pt-0 pb-0 float-right"
              (click)="enableEditingDomain()">{{editDomainBtnTxt}}</button> -->
          </div>
          <div class="col-3 pr-0 padl-5 text-center">
            <!-- <button  type="button" class="btn btn-outline-danger pt-0 pb-0 pl-1 pr-1"
              > -->
            <i *ngIf="isEditDomainEnabled" (click)="addDomain()" class="fas fa-plus-square cursor-pointer maroon"
              data-toggle="tooltip" data-placement="right" title="Add Domain"></i>
            <!-- &nbsp;Domain</button> -->
          </div>
        </div>

        <form class="mt-2" #domainForm="ngForm" novalidate (ngSubmit)="domainForm.form.valid">
          <div *ngIf="!isEditDomainEnabled">
            <div class="row mt-2" *ngFor="let domain of domains; let i=index;">
              <div class="col-9 pr-0">
                <input style="width:100%" class="form-control" type="text" [(ngModel)]="domain.name" name="dom{{i}}"
                  #dom="ngModel" disabled>
              </div>
            </div>
          </div>

          <div *ngIf="isEditDomainEnabled">
            <div class="row mt-2" *ngFor="let domain of domains; let i=index;">
              <div id="domain{{i}}" class="col-9 pr-0">
                <input type="text" style="width:100%" class="form-control"
                  pattern="^[a-zA-Z0-9][a-zA-Z0-9-]{0,63}[a-zA-Z0-9](?:\.[a-zA-Z]{2,15})+$" placeholder="example.com"
                  [(ngModel)]="domain.name" name="dom{{i}}" #dom="ngModel" required>
                <small class="text-danger text-center" *ngIf="dom.invalid && (dom.dirty || dom.touched)">
                  <p class="mb-0" *ngIf="dom.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!dom.errors.required">Invalid domain</p>
                </small>
              </div>
              <div class="col-3 text-center pr-0 padl-5">
                <i class="fas fa-times text-secondary pointer" data-toggle="tooltip" data-placement="right"
                  title="Remove" (click)="removeDomain(i)"></i>
              </div>
            </div>
          </div>
          <div *ngIf="isEditDomainEnabled" class="mt-2"><button type="submit" class="btn btn-primary border"
              [disabled]="domainForm.form.pristine || domainForm.form.invalid" (click)="updateDomains()">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isUpdateAccountClicked">
  <app-account-update (updateEmitter)="updateAccountData()" (cancelUpdateEmitter)="cancelUpdateAccount()">
  </app-account-update>
</div>